import { CONFIG } from '../../../../config'
import { authHttp } from '../http'
import { errorHandler } from '../../../util/error.service'
import { parseToMysqlFormat } from '../../../util/date.service'
import { getUsuarioInfo } from '../../../localstorage/localstorage.service'

const { ENVIROMENT } = CONFIG
const BASE_URL = `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/dashboard/status-operacoes`

const StatusOperacaoHttp = {
  async getStatusOperacao(pInicial, pFinal) {
    try {
      const dataInicial = parseToMysqlFormat(pInicial)
      const dataFinal = parseToMysqlFormat(pFinal)
      const { id: userId } = getUsuarioInfo()

      const url = BASE_URL + `?p_inicial=${dataInicial}&p_final=${dataFinal}&user_id=${userId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (e) {
      throw errorHandler(e)
    }
  },
}

export default StatusOperacaoHttp
